module.exports = __webpack_public_path__ + "img/glassquality_3.74a3875c.png";